const BASE_CALENDAR_URL = 'https://www.googleapis.com/calendar/v3/calendars'
const BASE_CALENDAR_ID_FOR_PUBLIC_HOLIDAY = 'holiday@group.v.calendar.google.com'

type InternationBankHol = {
  date: string
}

type InternationResponse = {
  start: InternationBankHol
  description: string
}

export const getUkHolidays = async () => {
  return await fetch('https://www.gov.uk/bank-holidays.json').then(res => res.json())
}

export const getInternationalHolidays = async (countryId: string) => {
  const url = `${BASE_CALENDAR_URL}/${countryId}%23${BASE_CALENDAR_ID_FOR_PUBLIC_HOLIDAY}/events?key=${process.env.REACT_APP_FIREBASE_API_KEY}`
  return await fetch(url)
    .then(response => response.json())
    .then(data => data.items.filter((x: InternationResponse) => x.description === 'Public holiday'))
    .then(data => data.map((x: InternationResponse) => x.start.date))
}
